// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sl-footer {
  background-color: #dfe1e2;
}

.h5-topic {
  margin-left: 17%;
}

.sl-list-1 {
  color: #1a4480;
  text-decoration: underline;
}

.sl-list li a {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
}

.sl-list-1 li a {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
}

.sl-list {
  color: #301a80;
  text-decoration: underline;
}

.sl-li {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 1.5;
  overflow: hidden;
}

.sl-list {
  color: #301a80;
  text-decoration: underline;
}

.sl-list li a {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
}

.sl-social-link img {
  display: block;
  height: 32px;
  width: 32px;
}

img {
  border-style: none;
  max-width: 100%;
}

*,
::after,
::before {
  box-sizing: inherit;
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}

.sl-footer__secondary-section {
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
  color: #1b1b1b;
  background-color: #ccecf2;
}

.sl-footer__contact-links {
  margin-top: 0;
  text-align: right;
}

.footer-social-block {
  display: inline-block;
  height: 100%;
}

.sl-identifier {
  font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06rem;
  line-height: 1.3;
  color: #fff;
  background-color: #112f4e;
  padding-bottom: 1rem;
}

.sl-identifier__slgov-description {
  display: flex;
  justify-content: center;
  line-height: 1.5;
}

.grid-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.3rem;
}

.footer-content {
  padding-top: 1px;
}

img {
  border-style: none;
  max-width: 100%;
}

*,
::after,
::before {
  box-sizing: inherit;
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}

.footer-social-block {
  display: inline-block;
  height: 100%;
}

.grid-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.3rem;
}

.last-update-css {
  margin-left: 85%;
  margin-bottom: -15px;
  font-size: 10px;
  margin-top: "10%" !important;
}

.number-style {
  margin-left: -5%;
}

.sitemap-css {
  color: white;
  margin-left: -375%;
  text-decoration: underline;
}

@media only screen and (max-width: 500px) {
  .sl-footer {
    background-color: #dfe1e2;
  }
  .h5-topic {
    margin-left: 17%;
  }
  .sl-list-1 {
    color: #1a4480;
    text-decoration: underline;
  }
  .sl-list li a {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  }
  .sl-list-1 li a {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  }
  .sl-list {
    color: #301a80;
    text-decoration: underline;
  }
  .sl-li {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    font-size: 1.06rem;
    line-height: 1.5;
    overflow: hidden;
  }
  .sl-list {
    color: #301a80;
    text-decoration: underline;
  }
  .sl-list li a {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  }
  .sl-social-link img {
    display: block;
    height: 32px;
    width: 32px;
  }
  img {
    border-style: none;
    max-width: 100%;
  }
  *,
  ::after,
  ::before {
    box-sizing: inherit;
  }
  img {
    overflow-clip-margin: content-box;
    overflow: clip;
  }
  .sl-footer__secondary-section {
    padding-bottom: 1.25rem;
    padding-top: 1.25rem;
    color: #1b1b1b;
    background-color: #ccecf2;
  }
  .sl-footer__contact-links {
    margin-top: 0;
    text-align: right;
  }
  .footer-social-block {
    display: inline-block;
    height: 100%;
  }
  .sl-identifier {
    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    font-size: 1.06rem;
    line-height: 1.3;
    color: #fff;
    background-color: #112f4e;
    padding-bottom: 1rem;
  }
  .sl-identifier__slgov-description {
    display: flex;
    justify-content: center;
    line-height: 1.5;
  }
  .grid-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.3rem;
  }
  .footer-content {
    padding-top: 1px;
  }
  img {
    border-style: none;
    max-width: 100%;
  }
  *,
  ::after,
  ::before {
    box-sizing: inherit;
  }
  img {
    overflow-clip-margin: content-box;
    overflow: clip;
  }
  .footer-social-block {
    display: inline-block;
    height: 100%;
  }
  .grid-row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.3rem;
  }
  .last-update-css {
    margin-left: 85%;
    margin-bottom: -15px;
    font-size: 10px;
  }
  .number-style {
    margin-left: -5%;
  }
}
/* Media query for screens smaller than 768px (typical mobile devices) */
@media (max-width: 767px) {
  .sl-footer {
    text-align: center;
    margin-left: -40px;
    padding-left: -10px; /* Adjust the padding for smaller screens */
  }
  /* Adjust styles for social media links */
  .sl-footer .footer-social-block {
    text-align: center;
    justify-content: center;
  }
  .sl-footer .sl-footer__social-links {
    justify-content: center;
  }
  /* Adjust styles for the contact information */
  .sl-footer .number-style {
    margin-top: 10px; /* Add spacing between phone number and address */
  }
  .sl-footer .sl-footer__slgov-description {
    padding-top: 2%; /* Adjust padding for smaller screens */
  }
  .mobile-view-content {
    margin-left: 25% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,cAAA;EACA,0BAAA;AACJ;;AAEE;EACE,sFAAA;AACJ;;AAGE;EACE,sFAAA;AAAJ;;AAIE;EACE,cAAA;EACA,0BAAA;AADJ;;AAIE;EAEE,sFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;;AAME;EACE,cAAA;EACA,0BAAA;AAHJ;;AAME;EACE,sFAAA;AAHJ;;AAOE;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAJJ;;AAOE;EACE,kBAAA;EACA,eAAA;AAJJ;;AAME;;;EAGE,mBAAA;AAHJ;;AAKE;EACE,iCAAA;EACA,cAAA;AAFJ;;AAKE;EACE,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;AAFJ;;AAKE;EACE,aAAA;EACA,iBAAA;AAFJ;;AAKE;EACE,qBAAA;EACA,YAAA;AAFJ;;AAKE;EAKE,sFAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AAZJ;;AAeE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAHJ;;AAME;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAHJ;;AAME;EACE,gBAAA;AAHJ;;AAME;EACE,kBAAA;EACA,eAAA;AAHJ;;AAKE;;;EAGE,mBAAA;AAFJ;;AAIE;EACE,iCAAA;EACA,cAAA;AADJ;;AAIE;EACE,qBAAA;EACA,YAAA;AADJ;;AAIE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AADJ;;AAIE;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BAAA;AADJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,0BAAA;AADF;;AAIE;EACE;IACE,yBAAA;EADJ;EAIE;IACE,gBAAA;EAFJ;EAKE;IACE,cAAA;IACA,0BAAA;EAHJ;EAME;IACE,sFAAA;EAJJ;EAQE;IACE,sFAAA;EANJ;EAUE;IACE,cAAA;IACA,0BAAA;EARJ;EAWE;IAEE,sFAAA;IAEA,kBAAA;IACA,gBAAA;IACA,gBAAA;EAXJ;EAcE;IACE,cAAA;IACA,0BAAA;EAZJ;EAeE;IACE,sFAAA;EAbJ;EAiBE;IACE,cAAA;IACA,YAAA;IACA,WAAA;EAfJ;EAkBE;IACE,kBAAA;IACA,eAAA;EAhBJ;EAkBE;;;IAGE,mBAAA;EAhBJ;EAkBE;IACE,iCAAA;IACA,cAAA;EAhBJ;EAmBE;IACE,uBAAA;IACA,oBAAA;IACA,cAAA;IACA,yBAAA;EAjBJ;EAoBE;IACE,aAAA;IACA,iBAAA;EAlBJ;EAqBE;IACE,qBAAA;IACA,YAAA;EAnBJ;EAsBE;IAKE,sFAAA;IAEA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,yBAAA;IACA,oBAAA;EA9BJ;EAiCE;IACE,aAAA;IACA,uBAAA;IACA,gBAAA;EAvBJ;EA0BE;IACE,aAAA;IACA,eAAA;IACA,WAAA;EAxBJ;EA2BE;IACE,gBAAA;EAzBJ;EA4BE;IACE,kBAAA;IACA,eAAA;EA1BJ;EA4BE;;;IAGE,mBAAA;EA1BJ;EA4BE;IACE,iCAAA;IACA,cAAA;EA1BJ;EA6BE;IACE,qBAAA;IACA,YAAA;EA3BJ;EA8BE;IACE,aAAA;IACA,eAAA;IACA,WAAA;EA5BJ;EA+BE;IACE,gBAAA;IACA,oBAAA;IACA,eAAA;EA7BJ;EAgCA;IACE,gBAAA;EA9BF;AACF;AAmCA,wEAAA;AACA;EACE;IAEE,kBAAA;IACA,kBAAA;IACA,mBAAA,EAAA,2CAAA;EAlCF;EAqCA,yCAAA;EACA;IACE,kBAAA;IACA,uBAAA;EAnCF;EAsCA;IACE,uBAAA;EApCF;EAuCA,8CAAA;EACA;IACE,gBAAA,EAAA,iDAAA;EArCF;EAwCA;IACE,eAAA,EAAA,uCAAA;EAtCF;EAwCF;IACE,2BAAA;EAtCA;AACF","sourcesContent":[".sl-footer {\n    background-color: #dfe1e2;\n  }\n  \n  .h5-topic {\n    margin-left: 17%;\n  }\n  \n  .sl-list-1 {\n    color: #1a4480;\n    text-decoration: underline;\n  }\n  \n  .sl-list li a {\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n  }\n  \n  .sl-list-1 li a {\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n  }\n  \n  .sl-list {\n    color: #301a80;\n    text-decoration: underline;\n  }\n  \n  .sl-li {\n    // margin-bottom: 10px;\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n    font-size: 1.06rem;\n    line-height: 1.5;\n    overflow: hidden;\n  }\n  \n  .sl-list {\n    color: #301a80;\n    text-decoration: underline;\n  }\n  \n  .sl-list li a {\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n  }\n  \n  .sl-social-link img {\n    display: block;\n    height: 32px;\n    width: 32px;\n  }\n  \n  img {\n    border-style: none;\n    max-width: 100%;\n  }\n  *,\n  ::after,\n  ::before {\n    box-sizing: inherit;\n  }\n  img {\n    overflow-clip-margin: content-box;\n    overflow: clip;\n  }\n  \n  .sl-footer__secondary-section {\n    padding-bottom: 1.25rem;\n    padding-top: 1.25rem;\n    color: #1b1b1b;\n    background-color: #ccecf2;\n  }\n  \n  .sl-footer__contact-links {\n    margin-top: 0;\n    text-align: right;\n  }\n  \n  .footer-social-block {\n    display: inline-block;\n    height: 100%;\n  }\n  \n  .sl-identifier {\n    background-color: #112f4e;\n  }\n  \n  .sl-identifier {\n    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n      sans-serif;\n    font-size: 1.06rem;\n    line-height: 1.3;\n    color: #fff;\n    background-color: #112f4e;\n    padding-bottom: 1rem;\n  }\n  \n  .sl-identifier__slgov-description {\n    display: flex;\n    justify-content: center;\n    line-height: 1.5;\n  }\n  \n  .grid-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.3rem;\n  }\n  \n  .footer-content {\n    padding-top: 1px;\n  }\n  \n  img {\n    border-style: none;\n    max-width: 100%;\n  }\n  *,\n  ::after,\n  ::before {\n    box-sizing: inherit;\n  }\n  img {\n    overflow-clip-margin: content-box;\n    overflow: clip;\n  }\n  \n  .footer-social-block {\n    display: inline-block;\n    height: 100%;\n  }\n  \n  .grid-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.3rem;\n  }\n  \n  .last-update-css {\n    margin-left: 85%;\n    margin-bottom: -15px;\n    font-size: 10px;\n    margin-top: \"10%\" !important;\n  }\n\n.number-style{\n  margin-left: -5%;\n}\n\n.sitemap-css{\n  color: white;\n  margin-left: -375%;\n  text-decoration: underline;\n}\n\n  @media only screen and (max-width: 500px) {\n    .sl-footer {\n      background-color: #dfe1e2;\n    }\n    \n    .h5-topic {\n      margin-left: 17%;\n    }\n    \n    .sl-list-1 {\n      color: #1a4480;\n      text-decoration: underline;\n    }\n    \n    .sl-list li a {\n      font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n        sans-serif;\n    }\n    \n    .sl-list-1 li a {\n      font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n        sans-serif;\n    }\n    \n    .sl-list {\n      color: #301a80;\n      text-decoration: underline;\n    }\n    \n    .sl-li {\n      // margin-bottom: 10px;\n      font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n        sans-serif;\n      font-size: 1.06rem;\n      line-height: 1.5;\n      overflow: hidden;\n    }\n    \n    .sl-list {\n      color: #301a80;\n      text-decoration: underline;\n    }\n    \n    .sl-list li a {\n      font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n        sans-serif;\n    }\n    \n    .sl-social-link img {\n      display: block;\n      height: 32px;\n      width: 32px;\n    }\n    \n    img {\n      border-style: none;\n      max-width: 100%;\n    }\n    *,\n    ::after,\n    ::before {\n      box-sizing: inherit;\n    }\n    img {\n      overflow-clip-margin: content-box;\n      overflow: clip;\n    }\n    \n    .sl-footer__secondary-section {\n      padding-bottom: 1.25rem;\n      padding-top: 1.25rem;\n      color: #1b1b1b;\n      background-color: #ccecf2;\n    }\n    \n    .sl-footer__contact-links {\n      margin-top: 0;\n      text-align: right;\n    }\n    \n    .footer-social-block {\n      display: inline-block;\n      height: 100%;\n    }\n    \n    .sl-identifier {\n      background-color: #112f4e;\n    }\n    \n    .sl-identifier {\n      font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto, Arial,\n        sans-serif;\n      font-size: 1.06rem;\n      line-height: 1.3;\n      color: #fff;\n      background-color: #112f4e;\n      padding-bottom: 1rem;\n    }\n    \n    .sl-identifier__slgov-description {\n      display: flex;\n      justify-content: center;\n      line-height: 1.5;\n    }\n    \n    .grid-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 1.3rem;\n    }\n    \n    .footer-content {\n      padding-top: 1px;\n    }\n    \n    img {\n      border-style: none;\n      max-width: 100%;\n    }\n    *,\n    ::after,\n    ::before {\n      box-sizing: inherit;\n    }\n    img {\n      overflow-clip-margin: content-box;\n      overflow: clip;\n    }\n    \n    .footer-social-block {\n      display: inline-block;\n      height: 100%;\n    }\n    \n    .grid-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 1.3rem;\n    }\n    \n    .last-update-css {\n      margin-left: 85%;\n      margin-bottom: -15px;\n      font-size: 10px;\n    }\n  \n  .number-style{\n    margin-left: -5%;\n  }\n  \n  }\n \n\n/* Media query for screens smaller than 768px (typical mobile devices) */\n@media (max-width: 767px) {\n  .sl-footer {\n    // padding: 20px; \n    text-align: center;\n    margin-left: -40px;\n    padding-left: -10px;/* Adjust the padding for smaller screens */ \n  }\n\n  /* Adjust styles for social media links */\n  .sl-footer .footer-social-block {\n    text-align: center;\n    justify-content:center;\n  }\n\n  .sl-footer .sl-footer__social-links {\n    justify-content: center;\n  }\n\n  /* Adjust styles for the contact information */\n  .sl-footer .number-style {\n    margin-top: 10px; /* Add spacing between phone number and address */\n  }\n\n  .sl-footer .sl-footer__slgov-description {\n    padding-top: 2%; /* Adjust padding for smaller screens */\n  }\n.mobile-view-content{\n  margin-left: 25% !important;\n}\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
